const normalizeDataAttribute = function (name) {
    return String(name)
        .replace(/^data-/, '')
        .replace(/[A-Z]/g, m => '-' + m.toLowerCase())
        .replace(/-+/g, '-')
        ;
};

const setFieldValue = function (field, value) {
    if (!field) {
        return;
    }

    if (field.type === 'checkbox') {
        field.checked = Boolean(value);
        return;
    }

    if (field.type === 'radio') {
        field.checked = field.value == value;
        return;
    }

    field.value = value ?? '';
    field.dispatchEvent(new Event('input', {bubbles: true}));
    field.dispatchEvent(new Event('change', {bubbles: true}));
};

// actionByFields = {
//   "data-pk-id": "data-mn-id",
//   "data-pk-name": "data-mn-name"
// }
const fillActionByFields = function (actionByFields, clickedRow) {
    // debugger;
    if (!actionByFields || !clickedRow) {
        return;
    }

    if (typeof actionByFields === 'string') {
        try {
            actionByFields = JSON.parse(actionByFields);
        } catch (e) {
            console.error('Некорректный JSON в data-picker-action', actionByFields);
            return;
        }
    }

    Object.entries(actionByFields).forEach(([pickerAttr, mainFormAttr]) => {
        const pickerDataName = normalizeDataAttribute(pickerAttr);
        const mainAttrName = normalizeDataAttribute(mainFormAttr);
        //support only latin letters
        const normalizedPickerDataName = pickerDataName
            .replace(/^data-/, '')
            .replace(/-([a-zA-Z])/g, (_, c) => c.toUpperCase());

        const value = clickedRow.dataset[normalizedPickerDataName];

        const targets = document.querySelectorAll(`[data-${mainAttrName}]`);

        if (targets.length > 0) {
            targets.forEach(target => {
                setFieldValue(target, value);
            });
        } else {
            console.warn("target not found:" + `[data-${mainAttrName}]` + ", value:" + value);
        }
    });
};

const createCell = function (value) {
    const td = document.createElement('td');
    td.textContent = value ?? '';
    return td;
};

const createDataAttrName = function (fieldCode) {
    return `data-pk-${String(fieldCode).replace(/_/g, '-')}`;
};

const fillRowDataAttributes = function (tr, item) {
    Object.entries(item).forEach(([fieldCode, value]) => {
        tr.setAttribute(createDataAttrName(fieldCode), value ?? '');
    });
};

const renderTableHead = function (headers) {
    const tableHead = document.querySelector('#globalPickerTable thead');

    if (!tableHead) {
        return;
    }

    tableHead.innerHTML = '';

    const tr = document.createElement('tr');

    Object.values(headers).forEach(title => {
        const th = document.createElement('th');
        th.textContent = title;
        tr.appendChild(th);
    });

    tableHead.appendChild(tr);
};

const spawnPicker = function (type, tip, fieldId, actionByFields) {
    const modalEl = document.getElementById('globalPickerModal');
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
    const titleEl = document.getElementById('globalPickerTitle');
    const searchEl = document.getElementById('globalPickerSearch');
    const tableBody = document.querySelector('#globalPickerTable tbody');

    titleEl.textContent = type === 'client' ? 'Выбор контрагента' : 'Выбор';
    tableBody.innerHTML = '<tr><td class="text-center">Загрузка...</td></tr>';

    modal.show();

    function loadData(query = '') {
        const url = `/admin/picker/${type}?tip=${encodeURIComponent(tip ?? '')}&q=${encodeURIComponent(query ?? '')}`;

        fetch(url)
            .then(res => res.json())
            .then(response => {
                const headers = response.headers || {};
                const items = response.items || response.data || [];

                const event = new CustomEvent('picker-loated', {
                    detail: {
                        response: response,
                        type: type,
                    }
                });

                document.dispatchEvent(event);

                const fieldCodes = Object.keys(headers);
                const colspan = Math.max(fieldCodes.length, 1);

                renderTableHead(headers);

                tableBody.innerHTML = '';

                if (items.length === 0) {
                    tableBody.innerHTML = `<tr><td colspan="${colspan}" class="text-center">Ничего не найдено</td></tr>`;
                    return;
                }


                items.forEach(item => {
                    const tr = document.createElement('tr');
                    tr.style.cursor = 'pointer';

                    fillRowDataAttributes(tr, item);

                    fieldCodes.forEach(fieldCode => {
                        tr.appendChild(createCell(item[fieldCode]));
                    });

                    tr.addEventListener('dblclick', () => {
                        fillActionByFields(actionByFields, tr);
                        const event = new CustomEvent('picker-dblclick', {
                            detail: {
                                tr: tr,
                                type: type,
                                actionByFields: actionByFields
                            }
                        });
                        document.dispatchEvent(event);
                        modal.hide();
                    });

                    tableBody.appendChild(tr);
                });
            })
            .catch(error => {
                console.error(error);
                tableBody.innerHTML = '<tr><td class="text-center text-danger">Ошибка загрузки данных</td></tr>';
            });
    }

    loadData();

    searchEl.oninput = (e) => {
        loadData(e.target.value);
    };
};

const init = function () {
    document.addEventListener('click', (event) => {
        const input = event.target.closest('[data-spawn-picker]');

        if (!input) {
            return;
        }

        spawnPicker(
            input.getAttribute('data-picker-type'),
            input.getAttribute('data-picker-tip'),
            input.getAttribute('data-picker-field'),
            input.getAttribute('data-picker-action'),
        );
    });
};

export default {init};
